import {create} from 'zustand';
import {
  getDigitList,
  getHomeGames,
  getKeralaList,
  getMatkaList,
} from '../home.service';
import {getGameProvider, postNewGameList, Provider} from './service';
import {
  NewGameListItem,
  NewGameListParams,
} from '@/common-pages/casino/casino.service';
import {
  DigitListItem,
  HomeGameFloorItem,
  KeralaListItem,
  MatkaListItem,
} from '../home.type';
import {getUrlParams} from '@/components/utils/utils';

type HomeStoreState = {
  selectedProvider: string;
  selectedGameType: string;
  casinoProviders: Provider[];
  gameTypes: HomeGameFloorItem[];
  keralaList: KeralaListItem[];
  digitList: DigitListItem[];
  matkaList: MatkaListItem[];
};

type HomeStoreActions = {
  getProviders: (type: 'casino' | 'liveCasino') => Promise<void>;
  fetchCasinoGames: (params: {
    page: number;
    pageSize: number;
  }) => Promise<NewGameListItem[]>;
  handleProviderChange: (provider: string) => void;
  getLotteryGames: () => Promise<void>;
  handleGameTypeChange: (gameType: string) => void;
};

const filterGames = ['casino', 'liveCasino', 'scratch'];

// 从URL参数获取默认的游戏类型
const getDefaultGameType = (): string => {
  const urlParams = getUrlParams();
  const gameParam = urlParams.game;
  return gameParam === 'casino' || !gameParam ? 'casino' : 'lottery';
};

export const useHomeStore = create<HomeStoreState & HomeStoreActions>(
  (set, get) => ({
    gameTypes: [],
    keralaList: [],
    digitList: [],
    matkaList: [],
    casinoProviders: [],
    selectedProvider: '0',
    selectedGameType: getDefaultGameType(),

    handleProviderChange: provider => {
      set({selectedProvider: provider});
    },
    handleGameTypeChange: (gameType: string) => {
      set({selectedGameType: gameType});
    },
    getProviders: async (type: 'casino' | 'liveCasino') => {
      const res = await getGameProvider(type);
      res.unshift({
        id: 0,
        name: 'Hot',
        logo: '/assets/images/providerIcon/Hot.webp',
      });
      set({casinoProviders: res, selectedProvider: res[0].id.toString()});
    },
    fetchCasinoGames: async ({page, pageSize}) => {
      const {selectedGameType, selectedProvider} = get();
      const params: NewGameListParams = {
        l1CategoryId: selectedGameType === 'casino' ? 2 : 3,
        l2CategoryId: '',
        pageNo: page,
        providerId: selectedProvider === '0' ? '' : selectedProvider,
        pageSize,
      };
      const res = await postNewGameList(params);
      return res.content || [];
    },
    getLotteryGames: async () => {
      const res = await Promise.all([
        getHomeGames(),
        getKeralaList(),
        getDigitList(),
        getMatkaList(),
      ]);
      const [homeGames, keralaList, digitList, matkaList] = res;
      const gameTypes = homeGames.filter(
        item =>
          !filterGames.includes(item.uniqueKey) ||
          (item.gamesList && item.gamesList.length > 0),
      );
      set({gameTypes: gameTypes, keralaList, digitList, matkaList});
    },
  }),
);
